import * as React from 'react';
import { Link } from './link';
import { TypeDefinitionContext, useTypeDefinition } from './type-definition-context';
import { TypeDefinitionObject } from './type-definition-object';
import { TypeDefinitionToken } from './type-definition-token';

/** Renders the return value after a function type definition. */
export const TypeDefinitionReturn = () => {
  const {
    language,
    ...ctx
  } = useTypeDefinition();
  let entity = ctx.entity.returns?.[0];
  let before: React.ReactNode = null;
  let after: React.ReactNode = null;
  if (language === 'dotnet' || language === 'java') {
    after = ' ';
    if (entity?.properties) {
      return <TypeDefinitionToken token={(entity.type ?? entity.key) + ' '} />;
    }
    if (!entity) {
      entity = {
        key: 'void',
        type: 'void'
      };
    }
  }
  if (language === 'go') {
    before = ' ';
    const entities = ctx.entity.returns ?? [];
    if (entities.length > 1) {
      return <>
          {' '}
          <span className="token punctuation">(</span>
          {entities.map((entity, i) => <React.Fragment key={entity.key}>
              <TypeDefinitionToken className="token go" token={entity.type} />
              {i < entities.length - 1 && <span className="token punctuation">, </span>}
            </React.Fragment>)}
          <span className="token punctuation">)</span>
        </>;
    }
    return <>
        {' '}
        <TypeDefinitionToken className="token go" token={entity?.type} />
      </>;
  }
  if (language === 'js') {
    before = <TypeDefinitionToken token=" => " />;
    if (!entity) {
      entity = {
        key: 'void',
        type: 'void'
      };
    }
  }
  if (language === 'ruby') {
    before = <TypeDefinitionToken token=" -> " />;
    if (!entity) {
      entity = {
        key: 'void',
        type: 'void'
      };
    }
  }
  if (language === 'python') {
    before = <TypeDefinitionToken token=" -> " />;
    if (entity?.title?.startsWith('dict')) {
      entity = {
        key: 'dict',
        type: 'dict'
      };
    }
    if (!entity) {
      entity = {
        key: 'None',
        type: 'None'
      };
    }
  }
  if (language === 'php') {
    before = <TypeDefinitionToken token=": " />;
    if (entity?.type === 'array') {
      before = <TypeDefinitionToken token=": array " />;
    }
  }
  if (!entity) {
    return null;
  }
  const shouldRender = (() => {
    if (entity.url) {
      return 'link';
    }
    if (entity.title) {
      return 'key';
    }
    if (entity.properties) {
      return 'object';
    }
    if (entity.type) {
      return 'type';
    }
    return 'key';
  })();
  return <TypeDefinitionContext.Provider value={{
    language,
    ...ctx,
    entity
  }} data-sentry-element="TypeDefinitionContext.Provider" data-sentry-component="TypeDefinitionReturn" data-sentry-source-file="type-definition-return.tsx">
      <>
        {before}
        {shouldRender === 'link' && <Link href={entity.url}>{entity.key}</Link>}
        {shouldRender === 'object' && <TypeDefinitionObject />}
        {shouldRender === 'type' && <TypeDefinitionToken token={entity.type} />}
        {shouldRender === 'key' && <TypeDefinitionToken token={entity.key} />}
        {after}
      </>
    </TypeDefinitionContext.Provider>;
};